export const tr = {
    'cant-adjust-phrase':
        'Arama sorgularının istatistiğine göre, belirtilen anahtar sözcük grubunu negatif anahtar sözcüklerin eklenmesiyle netleştirmek mümkün değildir.',
    'count-views-per-month': 'aylık gösterim sayısı',
    'load-more': 'Daha fazla yükle',
    'minus-word-header': 'Negatif anahtar sözcükler',
    'minus-word-request-example-header': 'Negatif anahtar sözcük içeren sorgu örnekleri',
    'phrase-adjustment-info-line-1':
        'Anahtar sözcük grubunu netleştirmek için istenilen negatif anahtar sözcüklerini işaretleyin.',
    'phrase-adjustment-info-line-2':
        'Sözcük grubuna negatif anahtar sözcük eklenmesi, içerisinde bu sözcük geçen tüm sorgularda reklam gösterimini engeller.',
    'shows-per-mounth': 'Aylık gösterim tahmini: {shows}'
};
